import { render, staticRenderFns } from "./generaOrdine.html?vue&type=template&id=7f16e5c2&"
import script from "./GeneraOrdine.vue?vue&type=script&lang=js&"
export * from "./GeneraOrdine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports